export default [
    {
        path: '/exemption/list',
        component: require('@/pages/ExemptionList').default,
        meta: {
            crumbs: [],
            security: (auth) => auth.can({ action: 'list', model: 'exemption' })
        }
    },
    {
        name: 'exemptionCreate',
        path: '/exemption/create/:equipmentId',
        component: require('@/pages/ExemptionCreate').default,
        props: (route) => ({
            equipmentId: +route.params.equipmentId,
        }),
        meta: {
            crumbs: [],
            security: (auth) => auth.can({ action: 'create', model: 'exemption' })
        }
    },
    {
        name: 'exemptionEdit',
        path: '/exemption/edit/:exemptionId',
        component: require('@/pages/ExemptionEdit').default,
        props: (route) => ({
            exemptionId: +route.params.exemptionId,
        }),
        meta: {
            crumbs: [],
            security: (auth) => auth.can({
                action: 'edit',
                model: 'exemption',
                arg: +auth.to.params.exemptionId
            })
        }
    },
    {
        name: 'exemptionView',
        path: '/exemption/view/:exemptionId',
        component: require('@/pages/ExemptionView').default,
        props: (route) => ({
            exemptionId: +route.params.exemptionId,
        }),
        meta: {
            back: { label: 'Exemption Requests', to: '/exemption/list' },
            security: (auth) => auth.can({ action: 'approve', model: 'exemption', arg: +auth.to.params.exemptionId })
        }
    },
]
